import { gql } from "@apollo/client";

import { remoteApiSpecFragment } from "../fragments";

export const getRemoteApiSpec = gql`
    query getSpecById($specId: ID!) {
        remoteApiSpec(input: { id: $specId }) {
            ...RemoteApiSpec
        }
    }

    ${remoteApiSpecFragment}
`;
